"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagsMenacingMelodyAbilityHandler = exports.MagsMenacingMelodyActorAbilityFactory = exports.MagsMenacingMelodyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class MagsMenacingMelodyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MagsMenacingMelody;
        this.__typeName = "MagsMenacingMelody";
    }
}
exports.MagsMenacingMelodyAbilityArgs = MagsMenacingMelodyAbilityArgs;
let MagsMenacingMelodyActorAbilityFactory = class MagsMenacingMelodyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MagsMenacingMelody", "AllEnemies", 0);
    }
};
MagsMenacingMelodyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MagsMenacingMelody")
], MagsMenacingMelodyActorAbilityFactory);
exports.MagsMenacingMelodyActorAbilityFactory = MagsMenacingMelodyActorAbilityFactory;
let MagsMenacingMelodyAbilityHandler = class MagsMenacingMelodyAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const agilityPerHit = Math.round(0.05 * container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Power));
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies).map((targetId, i) => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Sonic", 45)
                ],
            })),
            onHit(sequence) {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: allyId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, agilityPerHit)
                }));
            }
        });
    }
};
MagsMenacingMelodyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MagsMenacingMelody)
], MagsMenacingMelodyAbilityHandler);
exports.MagsMenacingMelodyAbilityHandler = MagsMenacingMelodyAbilityHandler;
